import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useFormContext, Controller } from 'react-hook-form';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core';
import { RegisterRfqInput } from '@generated/graphql';
import { RootState } from '@modules/index';
import { colorSet } from '@components/Provider';
import { CustomizedTypography } from '@components/Customized';
import FormInputLayout from '../Layout/FormInputLayout';
import { RequestInputCommonProps } from './types';

const AssemblyMetalMaskAvailablityControl: React.FC<RequestInputCommonProps> = ({
  error
}) => {
  const metalMaskAvailabilityDefaultValue = useSelector<RootState, boolean>(
    (state) => state.request.pcb?.metalMaskAvailablity ?? true
  );
  const { controlContainer } = useStyles();
  const [metalMaskInclude, setMetalMaskInclude] = useState<boolean>(
    metalMaskAvailabilityDefaultValue ?? true
  );
  const { control } = useFormContext<RegisterRfqInput>();

  return (
    <FormInputLayout label="메탈마스크 제공 여부" required={true}>
      <Controller
        data-cy="rfq-pcb-metalMaskAvailablity"
        contorl={control}
        name={'pcb.metalMaskAvailablity'}
        defaultValue={metalMaskAvailabilityDefaultValue ?? true}
        render={(renderProps) => (
          <div className={controlContainer}>
            <div
              className={clsx([
                'switch',
                {
                  active: metalMaskInclude
                }
              ])}
              onClick={(e) => {
                setMetalMaskInclude(true);
                renderProps.onChange(true);
              }}
            >
              <CustomizedTypography
                variant="body1"
                fontWeight="500"
                color="textPrimary"
              >
                예, 제공합니다.
              </CustomizedTypography>
            </div>
            <div
              className={clsx([
                'switch',
                {
                  active: !metalMaskInclude
                }
              ])}
              onClick={(e) => {
                setMetalMaskInclude(false);
                renderProps.onChange(false);
              }}
            >
              <CustomizedTypography
                variant="body1"
                fontWeight="500"
                color="textPrimary"
              >
                아니요, 제공하지 않아요.
              </CustomizedTypography>
            </div>
          </div>
        )}
      />

      {error && (
        <CustomizedTypography variant="caption" color="error">
          {error}
        </CustomizedTypography>
      )}
    </FormInputLayout>
  );
};

export default AssemblyMetalMaskAvailablityControl;

const useStyles = makeStyles((theme) => ({
  controlContainer: {
    display: 'flex',
    gap: '16px',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      gap: '8px'
    },
    '& .switch': {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      padding: '20px 18px',
      borderRadius: '12px',
      border: `1px solid ${colorSet.gray400}`,
      gap: '12px',
      '& img': {
        marginBottom: '12px'
      },
      '&:hover': {
        cursor: 'pointer'
      },
      '&.active': {
        backgroundColor: colorSet.gray100
      },
      '&:hover, &.active': {
        border: `2px solid ${colorSet.gray900}`,
        padding: '19px 17px'
      }
    }
  }
}));
